export { default } from "./PlayerCardIdentityView";
export type { PlayerCardIdentityViewProps } from "./PlayerCardIdentityView";
